import { TranslateService } from '@ngx-translate/core';
import { BehaviorSubject } from 'rxjs';
import {
  DocumentModel,
  DocumentStatus,
  DocUserStatus
} from 'src/app/Data/Entities/Documents/document.model';
//import { UserModel } from 'src/app/Data/Entities/User/user.model';
import { TableComponent } from '../../table/table/table.component';
import { ReportsTableStruct } from './reports-table-struct';
import { IDocumentTableDto } from 'src/app/Data/Services/DTO/document.DTO';

const mapDocumentStatus = {
  1: DocumentStatus.Draft,
  2: DocumentStatus.Sent,
  3: DocumentStatus.Accessed,
};

const mapUserStatus = {
  0: DocUserStatus.None,
  1: DocUserStatus.Sent,
  2: DocUserStatus.Accessed,
  999: DocUserStatus.Error,
};

export class ReportsDataModel {
  //users: UserModel[];
  documents: IDocumentTableDto[];
  protected reportsTableData$ = new BehaviorSubject<ReportsTableStruct[]>(null);
  private documentsDataStore = new Map<string, ReportsTableStruct>();
  
  
  constructor(
    //users: UserModel[],
    documents: IDocumentTableDto[],
    public translate: TranslateService
  ) {
    //this.users = users;
    this.documents = documents;
  }
//, users: UserModel[]

  // setRowTableDataModel(docs: DocumentModel[]): ReportsTableStruct[] {
  //   const reportsTableData: ReportsTableStruct[] = [];
  
  //   docs.forEach((doc) => {
  //     const rowTableData: ReportsTableStruct = {
  //       id: doc?.id,
  //       fileName: doc?.name,
  //       docStatus: doc?.status,
  //       userStatus: null,
  //       recipientCellData: [],
  //       LastUpdate: doc.log[doc.log.length - 1].timestamp.toString(),
  //       CreateDate: '',
  //       // Initialize metadata array here
  //       metadatas: [],
  //     };
  
  //     // Loop through metadata and add to the metadata array
  //     doc.metadatas?.forEach((data) => {
  //       rowTableData.metadatas.push(data); // Add metadata to the array
  //     });
  
  //     const translation = {
  //       tran: () =>
  //         this.translate.instant(doc?.status.toString(), {
  //           value: doc?.status.toString(),
  //         }),
  //     };
  
  //     doc.recipients.forEach((r, index) => {
  //       rowTableData.recipientCellData[index] = {
  //         friendlyName: r.userName,
  //         userStatus: r.status,
  //       };
  //     });
  


  //     doc.log.forEach((log) => {
  //       if (log.action === 'DocumentSent') {
  //         rowTableData.CreateDate = log.timestamp.toString();
  //       }
  //     });
  
  //     /* users.forEach((usr) => {
  //       if (!usr.id) {
  //         throw new Error('No usr id');
  //       }
  //       const filteredRecipients = doc.recipients.filter((recipient) => usr.id === recipient.user.id);
  
  //       filteredRecipients.forEach((du) => {
  //         rowTableData.userStatus = du.status;
  //       });
  //     }); */
  
  //     const firstRecipient = doc.recipients.find(r => r.type === 'To' || r.type === 'To' && r.status !== DocUserStatus.None);
  //       rowTableData.userStatus = firstRecipient?.status ?? null;

  //     this.documentsDataStore.set(rowTableData.id, rowTableData);
  //     reportsTableData.push(rowTableData);
  //   });
  //   TableComponent.setLoader(false);
  //   return reportsTableData;
  // }

  /* setRowTableDataModelForTableDto(docs: IDocumentTableDto[]): ReportsTableStruct[] {
    const reportsTableData: ReportsTableStruct[] = [];
  
    docs.forEach((doc) => {
      const row: ReportsTableStruct = {
        id: doc.id,
        fileName: doc.name,
        docStatus: DocumentStatus[doc.status as keyof typeof DocumentStatus],
        userStatus: doc.recipientStatus
          ? DocUserStatus[doc.recipientStatus as keyof typeof DocUserStatus]
          : null,
        recipientCellData: [
            {
              friendlyName: doc.recipientName ?? '-',
              userStatus: doc.recipientStatus
                ? DocUserStatus[doc.recipientStatus as keyof typeof DocUserStatus]
                : null,
            },
        ],
        LastUpdate: doc.lastUpdate ?? '',
        CreateDate: doc.createDate ?? '',
        metadatas: [],
      };
  
      this.documentsDataStore.set(row.id, row);
      reportsTableData.push(row);
    });
  
    TableComponent.setLoader(false);
    return reportsTableData;
  } */

    setRowTableDataModelForTableDto(docs: IDocumentTableDto[]): ReportsTableStruct[] {
      
      console.time('🔧 setRowTableDataModelForTableDto internal');
      const reportsTableData: ReportsTableStruct[] = [];
    
      docs.forEach((doc) => {
        const docStatusStr = mapDocumentStatus[+doc.status];
        const userStatusStr = doc.recipientStatus !== undefined ? mapUserStatus[+doc.recipientStatus] : null;
    
        const row: ReportsTableStruct = {
          id: doc.id,
          fileName: doc.name,
          docStatus: DocumentStatus[docStatusStr as keyof typeof DocumentStatus],
          userStatus: userStatusStr ? DocUserStatus[userStatusStr as keyof typeof DocUserStatus] : null,
          recipientCellData: [
            {
              friendlyName: doc.recipientName ?? '-',
              userStatus: userStatusStr ? DocUserStatus[userStatusStr as keyof typeof DocUserStatus] : null,
            },
          ],
          LastUpdate: doc.lastUpdate ?? '',
          CreateDate: doc.createDate ?? '',
          metadatas: [],
        };
    
        this.documentsDataStore.set(row.id, row);
        reportsTableData.push(row);
      });
    
      TableComponent.setLoader(false);
      console.timeEnd('🔧 setRowTableDataModelForTableDto internal');
      return reportsTableData;
    }

    setRowTableDataModelForTableDto_empty(docs: IDocumentTableDto[]): ReportsTableStruct[] {
      console.time('⚙️ map to ReportsTableStruct');
      
      const reportsTableData: ReportsTableStruct[] = docs.map((doc) => ({
        id: doc.id,
        fileName: doc.name,
        docStatus: doc.status as DocumentStatus, // ⚠️ просто cast
        userStatus: doc.recipientStatus as DocUserStatus, // ⚠️ просто cast
        LastUpdate: doc.lastUpdate ?? '',
        CreateDate: doc.createDate ?? '',
        recipientCellData: [
          {
            friendlyName: doc.recipientName ?? '-',
            userStatus: null // пока без enum
          },
        ],
        metadatas: [] // 🔕 пока отключили
      }));
    
      console.timeEnd('⚙️ map to ReportsTableStruct');
    
      TableComponent.setLoader(false);
      return reportsTableData;
    }


    setRowTableDataModelForTableDto_works(docs: IDocumentTableDto[]): ReportsTableStruct[] {
      const reportsTableData: ReportsTableStruct[] = [];
    
      // Мапы числовых значений в строковые enum-ключи
      const docStatusMap = ['None','Draft', 'Sent', 'Accessed', 'Error'] as const;
      const docUserStatusMap = ['None', 'Sent', 'Accessed', 'Error'] as const;
    
      docs.forEach((doc) => {
        const docStatusKey = docStatusMap[doc.status];
        const userStatusKey = doc.recipientStatus !== undefined
          ? docUserStatusMap[doc.recipientStatus]
          : null;
    
        const row: ReportsTableStruct = {
          id: doc.id,
          fileName: doc.name,
          docStatus: DocumentStatus[docStatusKey],
          userStatus: userStatusKey ? DocUserStatus[userStatusKey] : null,
          recipientCellData: [
            {
              friendlyName: doc.recipientName ?? '-',
              userStatus: userStatusKey ? DocUserStatus[userStatusKey] : null,
            },
          ],
          LastUpdate: doc.lastUpdate ?? '',
          CreateDate: doc.createDate ?? '',
          metadatas: [], // метаданные не заполняем — они больше не нужны в таблице
        };
    
        this.documentsDataStore.set(row.id, row);
        reportsTableData.push(row);
      });
    
      TableComponent.setLoader(false);
      return reportsTableData;
    }

    setRowTableDataModelForTableDto2(docs: IDocumentTableDto[]): ReportsTableStruct[] {
      const reportsTableData: ReportsTableStruct[] = [];
    
      docs.forEach((doc) => {
        /* const statusEnum = DocumentStatus[doc.status];// as keyof typeof DocumentStatus];
        const userStatusEnum = doc.recipientStatus
          ? DocUserStatus[doc.recipientStatus as keyof typeof DocUserStatus]
          : null; */
    
        const row: ReportsTableStruct = {
          id: doc.id,
          fileName: doc.name,
          /* docStatus: statusEnum,
          userStatus: userStatusEnum,
          recipientCellData: [
            {
              friendlyName: doc.recipientName ?? '-',
              userStatus: userStatusEnum,
            }, 


          ],*/
          docStatus: DocumentStatus[doc.status], // без преобразования в keyof
          userStatus: doc.recipientStatus != null ? DocUserStatus[doc.recipientStatus] : null,
          recipientCellData: [
            {
              friendlyName: doc.recipientName ?? '-',
              userStatus: doc.recipientStatus != null ? DocUserStatus[doc.recipientStatus] : null,
            },
          ],
          LastUpdate: doc.lastUpdate ?? '',
          CreateDate: doc.createDate ?? '',
          metadatas: [], // можно не трогать, если динамические колонки отключены
        };
    
        this.documentsDataStore.set(row.id, row);
        reportsTableData.push(row);
      });
    
      TableComponent.setLoader(false);
      return reportsTableData;
    }
  /* setRowTableDataModel(docs: DocumentModel[]): ReportsTableStruct[] {
    const reportsTableData: ReportsTableStruct[] = [];
  
    docs.forEach((doc) => {
      const rowTableData: ReportsTableStruct = {
        id: doc?.id,
        fileName: doc?.name,
        docStatus: doc?.status,
        userStatus: null,
        recipientCellData: [],
        LastUpdate: doc.log?.[doc.log.length - 1]?.timestamp?.toString() ?? '',
        CreateDate: '',
        metadatas: [],
      };
  
      doc.metadatas?.forEach((data) => {
        rowTableData.metadatas.push(data);
      });
  
      doc.recipients?.forEach((r, index) => {
        console.log('🧪 r in recipients:', r);
        rowTableData.recipientCellData[index] = {
          friendlyName: r.userEmail || r.userPhone||r.userName || r.user||'-',
          userStatus: r.status,
        };
      });
  
      doc.log?.forEach((log) => {
        if (log.action === 'DocumentSent') {
          rowTableData.CreateDate = log.timestamp?.toString() ?? '';
        }
      });
  
      const firstRecipient = doc.recipients?.find(
        (r) => r.type === 'To' && r.status !== DocUserStatus.None
      );
      rowTableData.userStatus = firstRecipient?.status ?? null;
  
      this.documentsDataStore.set(rowTableData.id, rowTableData);
      reportsTableData.push(rowTableData);
    });
  
    TableComponent.setLoader(false);
    return reportsTableData;
  } */
  
}
